import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d186312"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotLoaderPage: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/LoaderPage/LoaderPage.vue').default,HotHome: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Templates/Home/Home.vue').default,HotHomeBrazil: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Templates/HomeBrazil/HomeBrazil.vue').default,HotHomeLatam: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Templates/HomeLatam/HomeLatam.vue').default})
